<template>
	<div
		class="qw-image-uploader-empty-view el-upload el-upload--picture-card text-center relative"
		:class="{'circle-border-radius': isCircleComputed}"
		@click="onClicked"
		@mouseenter="onMouseEntered"
		@mouseleave="onMouseLeft"
		@touchstart="onTouchStart"
		@touchend="onTouchEnd">
		<QwImageUploaderSourcePickerView
			v-if="showSourcePicker && !isLoading"
			:pickerSources="pickerSources"
			@sourceSelected="onSourceSelected"/>
		<i v-else-if="!isLoading" class="fontello icon-plus font-size-8 fontello-mr-0"></i>
		<div v-else class="qw-image-uploader-empty-view__loading-host">
			<LoadingIndicator
				:text="loadingText"
				:isLoading="isLoading"/>
		</div>
	</div>
</template>

<script>
import QwImageUploaderSourcePickerView from "@/core/components/Controls/QwImageUploader/QwImageUploaderSourcePickerView.vue";
import LoadingIndicator from "@/core/components/LoadingIndicator.vue";

export default {
	name: "QwImageUploaderEmptyView",
	components: {LoadingIndicator, QwImageUploaderSourcePickerView},
	emits: ["clicked", "mouseEntered", "mouseLeft", "sourceSelected"],

	props: {
		isCircleComputed: Boolean,
		showSourcePicker: Boolean,
		pickerSources: {type: Array, default: () => []},
		isLoading: Boolean,
		loadingText: String,
	},

	methods: {
		onClicked() {
			if(!this.isLoading){
				this.$emit("clicked")
			}
		},

		onMouseEntered() {
			if(!this.isLoading){
				this.$emit("mouseEntered")
			}
		},

		onMouseLeft() {
			this.$emit("mouseLeft")
		},

		onSourceSelected(sourceItem) {
			if(!this.isLoading){
				this.$emit("sourceSelected", sourceItem)
			}
		},

		onTouchStart() {
		},

		onTouchEnd() {
		},
	},
}
</script>

<style lang="scss">
.qw-image-uploader-empty-view {
	&__loading-host {
		position: absolute;
		inset: 0;
		line-height: normal;
	}
}
</style>
